import Mixpanel from 'mixpanel-browser';
import { mixpanelEvents } from './mixpanelEvent';
import { appName } from '../localStorageHelpers';
import store from '@store/index';
export const trackEvent = ({ event, options, preAuth }) => {
    var _a;
    const state = store.getState();
    const user = (_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.user;
    if (!(user === null || user === void 0 ? void 0 : user.tenant_id) && !preAuth)
        return;
    const defaultOptions = Object.assign({ Application: appName, 'Application Version': process.env.version, 'Application Environment': process.env.APP_ENV, 'User Id': (user === null || user === void 0 ? void 0 : user.user_id) ? Number(user === null || user === void 0 ? void 0 : user.user_id) : undefined, 'Organization Id': (user === null || user === void 0 ? void 0 : user.tenant_id) ? Number(user === null || user === void 0 ? void 0 : user.tenant_id) : undefined }, options);
    Mixpanel.track(event, Object.assign({}, defaultOptions));
};
export const socialLoginInitiatedEvent = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_LOGIN_SOCIAL_MEDIA_INITIATED,
        options: options,
        preAuth: true,
    });
};
export const socialLoginSuccessEvent = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_LOGIN_SOCIAL_MEDIA_SUCCESS,
        options: options,
    });
};
export const instructionPageLandedEvent = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_INSTRUCTION_PAGE_LANDED,
        options: options,
    });
};
export const bulkAnswerSubmitted = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_ASSESSMENT_SUBMITTED,
        options: options,
    });
};
export const candidateAnswerSelected = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_ANSWER_SELECTED,
        options: options,
    });
};
export const candidateNextQuestionClicked = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_NEXT_QUESTION_CLICKED,
        options: options,
    });
};
export const candidateLoginOtpRequested = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_LOGIN_OTP_REQUESTED,
        options: options,
        preAuth: true,
    });
};
export const candidateLoginSocialMediaLoginFailed = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_LOGIN_SOCIAL_MEDIA_LOGIN_FAILED,
        options: options,
        preAuth: true,
    });
};
export const candidateLoginOtpFilledLoginSuccess = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_LOGIN_OTP_FILLED_LOGIN_SUCCESS,
        options: options,
    });
};
export const candidateScorePageNextClicked = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_SCORE_PAGE_NEXT_CLICKED,
        options: options,
    });
};
export const taskTakerFeedbackPage = (options) => {
    trackEvent({
        event: mixpanelEvents.TASK_TAKER_FEEDBACK_PAGE,
        options: options,
    });
};
export const candidateScorePageLoad = (options) => {
    trackEvent({
        event: mixpanelEvents.CANDIDATE_SCORE_PAGE_LOAD,
        options: options,
    });
};
